








































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { ComposeBanji$ } from "@/request/jxgl";
@Component({})
export default class BjglAddBanjiDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private banjis: any;
  private cs: any[] = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private addBanji() {
    this.cs.unshift({ 班级名称: "" });
  }
  private deleteThis(index) {
    this.$confirm(
      "删除该班级后，下属的学生账号将同步删除，您确定删除么？",
      "温馨提示"
    ).then(() => {
      this.cs.splice(index, 1);
    });
  }
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  private save() {
    let valid = true;
    this.cs.forEach((c: any) => {
      if (!c["班级名称"]) {
        valid = false;
      }
    });
    if (!valid) {
      this.$message.warning("班级名称不能为空");
      return;
    }
    const params = {
      班级: this.cs,
    };
    ComposeBanji$(this, params).then(() => {
      this.$message.success("编辑成功");
      this.$emit("update:ifVisible", false);
      this.$emit("change");
    });
  }
  private mounted() {
    this.cs = _.cloneDeep(this.banjis);
  }
}
